import script from "./PatientsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsPage.vue?vue&type=script&setup=true&lang=js"

import "./PatientsPage.vue?vue&type=style&index=0&id=3a28a904&lang=css"

const __exports__ = script;

export default __exports__